import { Injectable } from '@angular/core';
import { SalesByPeriodPrintingQuery, SalesByPeriodPrintingQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByPeriodPrintingQuery)
@Wrapper(SalesByPeriodPrintingQueryHandlerBase)
export class SalesByPeriodPrintingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
